import { Cookies } from 'atc-js';

const MCMID_COOKIE_NAME = 'AMCV_A9D33BC75245B2650A490D4D%40AdobeOrg';
const REGEX = /MCMID\|(.*?)\|/;
const REGEX2 = /MCMID%7C(.*?)%7C/;

export default function getMcmidCookie() {
    const cookies = new Cookies();
    const mcmidCookie = cookies.get(MCMID_COOKIE_NAME);
    const mcmid = REGEX.exec(mcmidCookie) || REGEX2.exec(mcmidCookie);
    return mcmid ? mcmid[1] : null;
}
